import {ColDef, ColGroupDef, GridApi, GridOptions, GridReadyEvent} from "ag-grid-community";
import {TestPanelComponent} from "../test-panel.component";

export type TestPanelRowData = {
    strike: number;
    [key: string]: any;
}

function createHedgeGroup(name: string, field: string): ColGroupDef {
    return {
        headerName: name,
        marryChildren: true,
        groupId: `${field}:group`,
        children: [
            {
                headerName: name,
                colId: `${field}:qty`,
                field: field,
            },
            {
                headerName: 'Trans',
                colId: `${field}:trans`,
                field: `${field}-trans`,
                hide: true,
            },
            {
                headerName: 'Outcome',
                colId: `${field}:outcome`,
                field: `${field}-outcome`,
                hide: true,
            }
        ]
    };
}

export function getGridOptions(this: TestPanelComponent) {

    // Pre-create 15 hedge groups so horizontal scroll is visible
    const hedgeGroups: ColGroupDef[] = [];
    for (let i = 1; i <= 15; i++) {
        hedgeGroups.push(createHedgeGroup(`Hedge ${i}`, `hedge${i}`));
    }

    return {
        columnDefs: [
            {
                headerName: 'Strike',
                field: 'strike',
                pinned: true,
                width: 80,
            },
            ...hedgeGroups,
            {
                headerName: 'Total',
                field: 'total',
            },
        ],

        defaultColDef: {
            width: 100,
            sortable: false,
            resizable: true,
        },

        onGridReady: (event: GridReadyEvent) => {
            this.onGridReady(event);
        },

        getContextMenuItems: params => {
            const colId = params.column?.getColId() || '';
            return [
                {
                    name: 'Add Hedge (setColumnDefs)',
                    action: () => {
                        this.addHedgeViaSetColumnDefs(colId);
                    }
                },
                {
                    name: 'Dump State',
                    action: () => {
                        console.log('Column State:', this.gridOptions.columnApi.getColumnState());
                        console.log('Column Defs:', this.gridOptions.api.getColumnDefs());
                    }
                },
            ];
        }
    } as GridOptions;
}
